export default {
      id: "color_dna-usage",
      viewBox: "0 0 142.3 142.3",
      url: __webpack_public_path__ + "sprite.svg#color_dna",
      toString: function () {
        return this.url;
      }
    }